import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The dark banded top of the booking page (logo, shop name, welcome
 * text). Renders the shop's uploaded hero image / gallery image /
 * accent solid — priority handled by the parent via `heroStyle`.
 * Shared between the wizard steps + success + settling screens.
 */
export const BookingHeader = ({ shop, heroStyle, logoStyle, showWelcome = false }) => (
  <div className="booking-header" style={heroStyle}>
    <Link
      to={`/shop/${shop.subdomain}`}
      data-testid="booking-header-home-link"
      style={{ display: 'contents', color: 'inherit', textDecoration: 'inherit' }}
    >
      <div
        className="booking-logo"
        style={
          shop.logo_url
            ? { ...logoStyle, backgroundImage: `url(${shop.logo_url})`, color: 'transparent' }
            : logoStyle
        }
      >
        {shop.name.charAt(0)}
      </div>
      <h1>{shop.name}</h1>
    </Link>
    {showWelcome && <p>{shop.welcome_text}</p>}
  </div>
);
